<template>
  <div>
    <div class="page-wrapper">
      <!-- Page Body Start-->
      <div class="container-fluid p-0">
        <div class="comingsoon">
          <div class="comingsoon-inner text-center"><img src="../../assets/images/logo-dark.png" width="200" alt="">
            <h5 class="text-uppercase">This is Profile page</h5>
            <router-link to="/">Go Home</router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: "profile"
  }
</script>

<style scoped>

</style>
